import e from "../managers/braze-instance.js";
import ie from "./feed-provider-factory.js";
export function subscribeToFeedUpdates(r) {
  if (e.rr()) return ie.er().Ws(r);
}
